export const privacyTypes = {
  EXTERNAL: 1,
  INTERNAL: 2,
  SERVICE: 3
} as const;

export const privacyTypeSlugs: Record<number, string> = {
  [privacyTypes.EXTERNAL]: 'external',
  [privacyTypes.INTERNAL]: 'internal',
  [privacyTypes.SERVICE]: 'service'
};

export const privacyTypeColors: Record<number, string> = {
  [privacyTypes.EXTERNAL]: 'none',
  [privacyTypes.INTERNAL]: 'green',
  [privacyTypes.SERVICE]: 'yellow'
};

export const resourceTypes = {
  IMAGE: 'image',
  VIDEO: 'video',
  FILE: 'file'
} as const;

export const resourceDisplayPriority: string[] = ['pdf', 'png', 'jpg'];

export type PrivacyType = (typeof privacyTypes)[keyof typeof privacyTypes];
export type ResourceType = (typeof resourceTypes)[keyof typeof resourceTypes];
